module.exports = __webpack_public_path__ + "img/20200801_130547.4d8925ab.jpg";